const commonMixin = {
  // created(){
  //   // console.warn(this.getTextByteLength( 'GUANGYUAN DONGYUAN ROAD B'))
  //   // console.warn(this.getTextByteLength('CHONGZHOU TANGAN EAST ROA'))
  // //  3   7   m-11
  // },
  computed: {
    dynamicColumnNames(){
      let arr  =[]
      this.columns.forEach((column)=>{
        if(column['type'] && column['type']=== 'dynamicColumnWidth'){
          arr.push(column['name'])
        }
      })
      return arr
    },
    // 动态行所在的位置
    dynamicColumnIndexes(){
      let colunmIndex = {}
      if(this.dynamicColumnNames && this.dynamicColumnNames.length > 0){
        this.dynamicColumnNames.forEach((name)=>{
          this.columns.forEach((item,index)=>{
            if(item.name === name){
              colunmIndex[name] = index
            }
          })
        })
      }
      return colunmIndex
    }
  },
  data() {
    return{
      dynamicMaxLabel:{},
      dynamicTextWidth:{},
      timeOutNumbers: [] // 定时器的number，记录清除使用
      // ,
      // dynamicColumnNames:[]
    }
  },
  methods: {
    // 计算每一列的动态宽度
    computerColumnWidth(data) {
      if (!data || data.length == 0) {
        return
      }
      // this.dynamicColumnNames = ['sysAccount']
      let cl = this.columns.length
      let that = this
      if (this.dynamicColumnNames && this.dynamicColumnNames.length > 0) {
        let dom = document.getElementById('dynamic-hide-label')
        this.dynamicMaxLabel = {}
        data.forEach((item) => {
          this.dynamicColumnNames.forEach((name) => {
            let label = item[name] || ''
            if (label) {
              if (this.dynamicMaxLabel[name]) {
                if (label) {
                  let maxLabel = this.dynamicMaxLabel[name].label + ''
                  if(this.isDoubleLength(label,maxLabel)){
                    let w1 = this.getWithByDom(dom, null, label)
                    let w2 = this.dynamicMaxLabel[name].width
                    if (w1 > w2) {
                      this.dynamicMaxLabel[name].label = label
                      this.dynamicMaxLabel[name].width = w1
                    }
                  }
                }
              } else {
                this.dynamicMaxLabel[name] = {label, width: this.getWithByDom(dom, null, label)}
              }
            }
          })
        })
        let obj = this.dynamicMaxLabel
        for (const key in obj) {
          let objWidth = obj[key]
          let index = this.dynamicColumnIndexes[key]
          let label = objWidth.label
          if (index >= 0 && index < cl) {
            let column = that.columns[index]
            let realWidth = this.realGetWidthByDom(dom, column.width, label)
            // console.error(label, objWidth)
            let w = parseFloat(column.width)
             // w = objWidth.width + 10
            w = realWidth + 10
            // console.error(label, realWidth)
            if (column.minWidth && w > column.minWidth) {
              column.width = w
            } else if (w > column.width) {
              column.minWidth = column.width
              column.width = w
            }
          }
        }
      }
    },
    // 判断当前的文本和上次保存的最大文本是不是2倍的差距，有比如1111和 ’您您您您‘,有两倍的差距才进行计算。不然没有必要
    isDoubleLength(currentText = '', lastMaxText = '') {
      currentText += ''
      lastMaxText += ''
     return currentText.length * 2 > lastMaxText.length
    },
    getTextByteLength(text = '',fontSize = 12) {
      let byteLength = 0
      text += ''
      for (const char of text) {
         if (char >= '\u4e00' && char <= '\u9fa5' || char === '（' || char === '）' || char === 'm' || char === 'M' || char === '+' || char === '-') {
          // 如果是中文字符，为字符分配12个单位宽度
           byteLength ++
        } else {
          // 其他种类字符，为字符分配8个单位宽度
           byteLength +=0.5
        }
      }
      return byteLength * fontSize
    },
    getWithByDom(dom, defaultWidth = 0, text) {
      if (text && this.dynamicTextWidth[text]) {
        return this.dynamicTextWidth[text]
      }
      let w = defaultWidth;
      // let flexWidth = 0
      // text = text + ''
      // for (const char of text) {
      //
      //   if (char == '1' || char === 'i' || char == 'l' || char == '|' || char === '(' || char === ')' || char === '.') {
      //     flexWidth += 5
      //   } else if ((char >= 'A' && char <= 'Z')) { // 大写字符分配 9个单位宽度
      //     flexWidth += 9
      //   } else if ((char >= 'a' && char <= 'z')) { // 小写8个单位宽度
      //     flexWidth += 8
      //   } else if (char >= '\u4e00' && char <= '\u9fa5' || char === '（' || char === '）') {
      //     // 如果是中文字符，为字符分配12个单位宽度
      //     if(char === ''){}
      //     flexWidth += 12.05
      //   } else {
      //     // 其他种类字符，为字符分配8个单位宽度
      //     flexWidth += 8
      //   }
      // }
      // console.error(flexWidth, text,w)
      let flexWidth = this.getTextByteLength(text)
      if (flexWidth > w) {
        w = flexWidth
      }
      this.dynamicTextWidth[text] = flexWidth

      // console.error(flexWidth, text,w)
      return w
    },
    realGetWidthByDom(dom, defaultWidth = 0, text) {
      let w = parseFloat(defaultWidth)
      if (dom) {
        dom.innerHTML = ''
        if (text) {
          dom.innerHTML = text
        }
        if (dom.offsetWidth) {
          w = dom.offsetWidth
        } else if (dom.currentStyle) {
          w = parseFloat(obj.currentStyle['width'])
        } else {
          w = parseFloat(window.getComputedStyle(dom, null)['width'])
        }
      }
      return  parseFloat(w)
    }
  }
}
export default commonMixin



// WEBPACK FOOTER //
// ./src/mixins/dynamicColumns.js